// extracted by mini-css-extract-plugin
export var inlineLink = "_4h-0";
export var inlineLinkButton = "_4h-1";